var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.366 18.44l4.921-5.806a1.224 1.224 0 111.854 1.598l-6.216 7.087a2 2 0 01-1.504.681h-.842a2 2 0 01-1.504-.681L3.866 14.24a1.234 1.234 0 011.855-1.627l5.11 5.828V3.267a1.267 1.267 0 012.535 0v15.174z",
    fill: "#26E5E9"
  })));
};
export default SvgArrowDown;